import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/attendDaily/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function getObj (params) {
  return axios({
    url: `/attendDaily/listHour`,
    method: 'GET',
    params: {
      ...params
    }
  })
}
export function putObj (params) {
  return axios({
    url: `/attendDaily/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
export function exportExcel (params) {
  return axios({
    url: `/attendDaily/exportExcel`,
    responseType: 'blob',
    method: 'GET',
    params: {
      ...params
    }
  })
}
// 5-12fix 获取工人考勤列表
export function newListHour (params) {
  return axios({
    url: `/attendDaily/newListHour`,
    method: 'GET',
    params: {
      ...params
    }
  })
}
// 5-12 fix 提交考勤
export function updateDetail (params) {
  return axios({
    url: `/attendDaily/updateDetail`,
    method: 'POST',
    data: {
      ...params
    }
  })
}
// 删除工人考勤
export function del (params) {
  return axios({
    url: `/attendDaily/del`,
    method: 'DELETE',
    params: {
      ...params
    }
  })
}
